<ng-container>
  @if (resAsync | async) {
    <div>
      @if (isTicketLicensed) {
        <p style="padding-left: 10px">{{ res.get('Order-Selection-Generic-WelcomeMessage') }}</p>
        <p style="padding-left: 10px">{{ res.get('Workmode-Selection-HeaderMessage') }}</p>

        <div>
          <p style="font-size: 30px; font-weight: bold; margin-bottom: 10px; padding-left: 10px">
            {{ res.get('Tickets-Selection-TitleTickets') }}
          </p>
          <app-ticket-selection></app-ticket-selection>
        </div>

        <div>
          <app-order-selection></app-order-selection>
        </div>
      } @else {
        @if (!isTicketLicensed) {
          <div>
            <p style="padding-left: 10px">
              {{ res.get('Order-Selection-Generic-WelcomeMessage') }}
            </p>
            <p style="padding-left: 10px">
              {{ res.get('Order-Selection-SelectOrder') }}
            </p>
          </div>
        }
        <app-order-selection></app-order-selection>
      }
    </div>
  }
</ng-container>
